<SidebarShell
  :logo="bolide_short_logo"
  :brand_title="brand_name"
  :brand_subtitle="brand_subtitle"
  :initials="initials"
  :full_name="full_name"
  :is_admin="is_admin"
  @brand-click="backToGlobal"
>
  <!-- HEADER ACTIONS -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions" />
  </template>

  <!-- CONTEXT -->
  <template #context>
    <SidebarContext
      :main_label="active_property?.title"
      :sub_label="active_property?.description"
      icon="bi bi-building"
      :sectors="sectors"
      active_sector="property"
      :items="propertiesFormatted"
      :active_id="active_property?.id"
      :open="dropdownOpen"
      :top_label="can_access_portfolio ? entity_name : ''"
      :top_subtitle="entity_subtitle"
      @toggle="toggleDropdown"
      @select="switchProperty"
      @select-top="backToGlobal"
      @select-sector="select_sector"
    />
  </template>

  <!-- MENU -->
  <template #menu>
    <div class="sidebar-menu px-3 mt-3 w-100">
      <!-- DYNAMIC MENU ITEMS -->
      <div
        v-for="item in menuItems"
        :key="item.key"
        class="sidebar-menu-item d-flex align-items-center py-2 px-2 rounded-3 w-100 cursor-pointer"
        :class="[
          active_menu_item === item.key
            ? 'bg-danger-subtle text-danger border-start border-3 border-danger'
            : 'text-muted'
        ]"
        :aria-label="item.label"
        @click="selectPropertyMenuItem(item.key)"
      >
        <!-- CUSTOM LOGO -->
        <template v-if="item.icon === 'custom'">
          <img
            :src="item.logo"
            :alt="item.label"
            class="sidebar-menu-icon sidebar-logo-icon me-2 cursor-pointer"
          />
        </template>

        <!-- NORMAL ICON -->
        <template v-else>
          <i
            :class="[
              item.icon,
              'sidebar-menu-icon',
              'me-2',
              'cursor-pointer',
              active_menu_item === item.key ? 'text-danger' : 'text-muted'
            ]"
            :aria-label="item.label"
          ></i>
        </template>

        <!-- LABEL -->
        <p class="sidebar-menu-label sidebar-menu-text fw-semibold text-xs mb-0 cursor-pointer">
          {{ item.label }}
        </p>
      </div>
    </div>
  </template>
</SidebarShell>
